var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"me-simple-button",class:_vm.color,attrs:{"href":_vm.url}},[_c('span',{staticClass:"me-simple-button__link",domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }